import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Table,
  TableRow,
  TableCell,
  TableBody,
  Grid,
  Divider,
  TableHead,
  useMediaQuery,
  useTheme
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { findProductById } from "../../../User/State/Product/Action";
import dayjs from "dayjs"; // ✅ correct
import { getVendorProfile } from "../../State/Vendor/Action";
import ImagePopup from "../../../Common/ImagePopup";
import defaultImage from "../../../Common/productDefaultImage.png"

const ProductDetailsModal = ({ open, onClose, row }) => {
  const { products, vendorProfile } = useSelector((store) => store);
  const dispatch = useDispatch();
  const [product, setProduct] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [imageOpen, setImageOpen] = useState(false);
  const [imageUrl, setImageUrl] = useState("");

  // 1. Fetch product only on row change
  useEffect(() => {
    dispatch(findProductById(row?.id));
    dispatch(getVendorProfile())
  }, [dispatch, row?.id]);

  useEffect(() => {
    if (products.product) {
      setProduct(products.product);
    }
  }, [products.product]);

  const handleModalClose = () => {
    setProduct(null)
    onClose(); // call parent close
  };


  if (!product) return null;

  const renderImages = () => {
    if (!product.images || product.images.length === 0) {
      return (
        <TableRow>
          <TableCell colSpan={4} align="center">
            No images found.
          </TableCell>
        </TableRow>
      );
    }

    return product.images.map((img) => (
      <TableRow key={img.id}>
        <TableCell>{img.productColor?.color?.name}</TableCell>
        <TableCell>
          <img
            src={img.fullUrl || defaultImage}
            alt={product?.title}
            style={{
              width: 30,
              height: 30,
              objectFit: "cover",
              borderRadius: 4,
              border: img.isPrimary ? "2px solid green" : "1px solid gray",
              cursor: "pointer"
            }}
            onClick={() => { setImageOpen(true); setImageUrl(img?.fullUrl) }}
          />
        </TableCell>
        <TableCell>{img.isPrimary ? "Yes" : "No"}</TableCell>
      </TableRow>
    ));
  };

  const showActions = !vendorProfile.vendor && row?.productStatus === "APPROVED"; // or from prop


  const renderVariants = () => {
    if (!product.variants || product.variants.length === 0) {
      return (
        <TableRow>
          <TableCell colSpan={6} align="center">
            No variants available.
          </TableCell>
        </TableRow>
      );
    }

    return product.variants.map((v) => (
      <TableRow key={v.id}>
        <TableCell>{v.productColor?.color?.name}</TableCell>
        <TableCell>{v.size?.name}</TableCell>
        <TableCell>{v.price?.toFixed(2)}</TableCell>
        <TableCell>{v.vendorDiscountPrice?.toFixed(2)}</TableCell>
        <TableCell>{v.vendorActualPrice?.toFixed(2)}</TableCell>
        <TableCell>{v.vendorIGstPrice?.toFixed(2)}</TableCell>
        <TableCell>{v.vendorPrice?.toFixed(2)}</TableCell>
        {showActions && (
          <>
            <TableCell>{v.marginPrice?.toFixed(2)}</TableCell>
            <TableCell>{v.adminDiscountPrice?.toFixed(2)}</TableCell>
            <TableCell>{v.adminIGstPrice?.toFixed(2)}</TableCell>
            <TableCell>{v.adminPrice?.toFixed(2)}</TableCell>
          </>
        )}
        <TableCell>{v.stockQuantity}</TableCell>
        <TableCell>{v.sku}</TableCell>
      </TableRow>
    ));
  };

  const renderAttributes = () => {

    if (product.attributes?.length === 0) {
      return (
        <TableRow>
          <TableCell colSpan={5} align="center">
            No Attributes available.
          </TableCell>
        </TableRow>
      );
    }

    return product.attributes?.map((attr) => (
      <TableRow key={attr.id}>
        <TableCell>
          {attr.name}
        </TableCell>
        <TableCell>
          {attr.value}
        </TableCell>
      </TableRow>
    ));
  };

  const renderOffers = () => {

    if (product.offers?.length === 0) {
      return (
        <TableRow>
          <TableCell colSpan={5} align="center">
            No offers available.
          </TableCell>
        </TableRow>
      );
    }

    return product.offers?.map((offer) => (
      <TableRow key={offer.id}>
        <TableCell>{offer.discountPercentage}%</TableCell>
        <TableCell>
          {offer.startDate ? dayjs(offer.startDate).format("YYYY-MM-DD HH:mm") : "----"}
        </TableCell>
        <TableCell>
          {offer.endDate ? dayjs(offer.endDate).format("YYYY-MM-DD HH:mm") : "----"}
        </TableCell>
      </TableRow>
    ));
  };


  return (
    <Dialog fullScreen={isMobile} maxWidth="md" open={open} onClose={onClose}>
      <DialogTitle>
        Product Details
        <IconButton
          edge="end"
          color="inherit"
          onClick={handleModalClose}
          sx={{ position: "absolute", right: 16, top: 16 }}
        >
          <Close />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ p: 3 }}>
        <Grid container spacing={4}>
          {/* Product Info */}
          <Grid item xs={12} md={7}>
            <Typography variant="h6" gutterBottom>
              Product Info
            </Typography>
            <Table size="small">
              <TableBody>
                <TableRow>
                  <TableCell>P-ID</TableCell>
                  <TableCell>{product.productId}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Title</TableCell>
                  <TableCell>{product.title}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Description</TableCell>
                  <TableCell>{product.description}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Category Hyrarchy</TableCell>
                  <TableCell>{product.category?.name} - {product.subCategory?.name} - {product.productCategory?.name}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Color</TableCell>
                  <TableCell>{product.colors[0].color?.name}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Brand</TableCell>
                  <TableCell>{product.brand?.name}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>GST</TableCell>
                  <TableCell>{"IGST-" + product.igst + "% , CGST-" + product.cgst + "% , SGST-" + product.sgst + "%"}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Status</TableCell>
                  <TableCell>
                    <span
                      className={`text-white px-2 py-1 rounded-full text-xs ${product.productStatus === "APPROVED"
                        ? "bg-[#369236]"
                        : product.productStatus === "REJECT"
                          ? "bg-[#592545]"
                          : product.productStatus === "PENDING"
                            ? "bg-[gray]"
                            : "bg-[#36FD56]"
                        }`}
                    >
                      {product.productStatus}
                    </span></TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Grid>

          {/* Images */}
          <Grid item xs={12} md={5}>
            <Typography variant="h6" gutterBottom>
              Images
            </Typography>
            <Table size="small">
              <TableHead color="white">
                <TableRow>
                  <TableCell>Product Color</TableCell>
                  <TableCell>Image</TableCell>
                  <TableCell>Primary</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>{renderImages()}</TableBody>
            </Table>
          </Grid>

          {/* Variants */}
          <Grid item xs={12}>
            <Divider sx={{ my: 2 }} />
            <Typography variant="h6" gutterBottom>
              Variants
            </Typography>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Product Color</TableCell>
                  <TableCell>Size</TableCell>
                  <TableCell>Price</TableCell>
                  <TableCell>Discount Price</TableCell>
                  <TableCell>Actual Price</TableCell>
                  <TableCell>GST Price</TableCell>
                  <TableCell>Total Price</TableCell>
                  {showActions && (
                    <>
                      <TableCell>Margin Price</TableCell>
                      <TableCell>Admin Discount Price</TableCell>
                      <TableCell>GST Price</TableCell>
                      <TableCell>Admin Price</TableCell>
                    </>
                  )}
                  <TableCell>Stock</TableCell>
                  <TableCell>SKU</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>{renderVariants()}</TableBody>
            </Table>
          </Grid>

          {/* attributes */}
          <Grid item xs={12} md={6}>
            <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
              Attributes
            </Typography>
            <Table size="small" sx={{ mb: 2 }}>
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Value</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>{renderAttributes()}</TableBody>
            </Table>
          </Grid>

          {/* offers */}
          {showActions && (
            <Grid item xs={12} md={6}>
              <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
                Offers
              </Typography>
              <Table size="small" sx={{ mb: 2 }}>
                <TableHead>
                  <TableRow>
                    <TableCell>Discount %</TableCell>
                    <TableCell>Start Date</TableCell>
                    <TableCell>End Date</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>{renderOffers()}</TableBody>
              </Table>
            </Grid>
          )}
        </Grid>
      </DialogContent>
      {/* Common Popup */}
      <ImagePopup
        open={imageOpen}
        onClose={() => setImageOpen(false)}
        imageUrl={imageUrl}
      />
    </Dialog>
  );
};

export default ProductDetailsModal;
